// src/data/dealerSpecialties.js

const DEALER_SPECIALTIES = [
    "Retail Gun Store",
    "Online Dealer",
    "Gunsmith",
    "Range / Shooting Club",
    "Class 3 / NFA Dealer",
    "Pawn Shop",
    "Private Collector",
    "Home-Based Dealer",
    "Manufacturer",
    "Instructor / Trainer",
  ];

export default DEALER_SPECIALTIES;